import { Button } from "@rio-cloud/rio-uikit";
import { useNavigate } from "react-router-dom";

interface RestrictAreaProps {
    title?: string;
    message?: string;
    showBackButton?: boolean;
    backButtonText?: string;
    backButtonPath?: string;
    customIcon?: string;
}

export const RestrictArea = ({
    title = "Acesso Restrito",
    message = "Você não possui permissão para acessar esta área. Entre em contato com o administrador do sistema para solicitar acesso.",
    showBackButton = true,
    backButtonText = "Voltar",
    backButtonPath = "/",
    customIcon = "rioglyph-lock"
}: RestrictAreaProps) => {
    const navigate = useNavigate();

    const handleBackClick = () => {
        if (backButtonPath) {
            navigate(backButtonPath);
        } else {
            navigate(-1);
        }
    };

    return (
        <div className="flex items-center justify-center h-[calc(100vh-120px)] bg-gray-50 dark:bg-neutral-900 p-4">
            <div className="max-w-2xl w-full bg-white dark:bg-neutral-800 rounded-lg shadow-lg p-8 text-center">
                <div className="mb-6">
                    <span className={`rioglyph ${customIcon} text-color-danger text-size-h1`} />
                </div>

                <h1 className="text-2xl font-bold text-gray-900 dark:text-neutral-100 mb-4">
                    {title}
                </h1>

                <p className="text-gray-600 dark:text-neutral-300 mb-6 leading-relaxed">
                    {message}
                </p>

                <p className="text-sm text-gray-500 dark:text-neutral-400 mb-8">
                    Se você acredita que isso é um erro, entre em contato com o suporte técnico.
                </p>

                {showBackButton && (
                    <div className="flex justify-center">
                        <Button 
                            bsStyle="primary" 
                            onClick={handleBackClick}
                            className="px-6 py-2"
                        >
                            {backButtonText}
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};